import React, { useState } from "react";
import {
  Card,
  Row,
  Col,
  Dropdown,
  Form,
  Button,
} from "react-bootstrap";
import {
  FiMoreVertical,
  FiMail,
  FiPhone,
  FiMapPin,
  FiEdit,
  FiTrash2,
  FiGrid,
  FiList,
} from "react-icons/fi";
import { FaFacebookF } from "react-icons/fa";
import { Link } from "react-router-dom";



import EditContactModal from "../../../components/modals/contacts/edit-contacts/EditContactModal";
import DeleteModal from "../../../components/modals/contacts/edit-contacts/DeleteModal";
import ContactHeader from "../../../components/crm/contact/ContactHeader";
import AddContactModal from "../../../components/modals/contacts/add-contacts/AddContactModal";
const contacts = [
  {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
       image: "/assets/img/users/user-49.jpg",

    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
        image: "/assets/img/users/user-50.jpg",


    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
         image: "/assets/img/users/user-51.jpg",


    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
         image: "/assets/img/users/user-02.jpg",


    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
       image: "/assets/img/users/user-52.jpg",


    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
      image: "/assets/img/users/user-57.jpg",


    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
      image: "/assets/img/users/user-54-1.jpg",


    rating: 4.2,
  },
    {
    id: 1,
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "(163) 2459 315",
    country: "Germany",
       image: "/assets/img/users/user-49.jpg",

    rating: 4.2,
  },
  // Add remaining contacts same format
];

export default function ContactGrid() {
  const [view, setView] = useState("grid");
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [contactShow, setContactShow] = useState(false);
  const filtered = contacts.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
        <div style={{ padding: "15px", background: "#f8f9fa" }}  >
            <ContactHeader
        title="Contact Grid"
        openModal={() => setContactShow(true)}
      />
      {/* HEADER */}
      <Card style={{  background: "#ffff" }} className="mb-3">
        <Card.Body className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h5 className="mb-0">Contact Grid</h5>

          <div className="d-flex gap-2 flex-wrap align-items-center">
            {/* SEARCH */}
    

            {/* VIEW TOGGLE */}
            {/* <Button
              variant={view === "grid" ? "warning" : "light"}
              size="sm"
              onClick={() => setView("grid")}
            >
              <FiGrid />
            </Button>
            <Button
              variant={view === "list" ? "warning" : "light"}
              size="sm"
              onClick={() => setView("list")}
            >
              <FiList />
            </Button> */}

            {/* SORT */}
            <Dropdown>
              <Dropdown.Toggle size="sm" className="border border-1" variant="light">
                Sort By : Last 7 Days
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                {[
                  "Recently Added",
                  "Ascending",
                  "Descending",
                  "Last Month",
                  "Last 7 Days",
                ].map((item, i) => (
                  <Dropdown.Item
                    key={i}
                    className="custom-dropdown"
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Body>
      </Card>

      {/* GRID */}
      <Row>
        {filtered.map((c) => (
          <Col md={3} sm={6} xs={12} key={c.id} className="mb-3">
            <Card className="contact-card text-center">
              <Card.Body>
                {/* TOP */}
                <div className="d-flex justify-content-between">
                  <Form.Check />
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="light" size="sm">
                      <FiMoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          setSelected(c);
                          setShowEdit(true);
                        }}
                      >
                        <FiEdit /> Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setSelected(c);
                          setShowDelete(true);
                        }}
                      >
                        <FiTrash2 /> Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* IMAGE */}
                <div className="avatar-wrapper">
                  <img src={c.image} alt="" />
                  <span className="status-dot"></span>
                </div>

                {/* NAME */}
                <h6 className="mt-2 ">{c.name}</h6>
                <span className="badge-role text-start">{c.role}</span>

                {/* DETAILS */}
                <div className="contact-info text-start">
                  <p><FiMail /> [email protected]</p>
                  <p><FiPhone /> {c.phone}</p>
                  <p><FiMapPin /> {c.country}</p>
                </div>

                {/* SOCIAL */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="social-icons">
                    <Link to="/mail"><FiMail /></Link>
                    <Link to="/call"><FiPhone /></Link>
                    <Link to="/chat"><FiMail /></Link>
                    <Link to="/facebook"><FaFacebookF /></Link>
                  </div>
                  <span className="rating">⭐ {c.rating}</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
        <style>
          {
            `
            .contact-card {
  border-radius: 6px;
  border: 1px solid #eee;
  transition: 0.3s;
}
.contact-card:hover {
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
}


.badge-role {
  background: #ffe4ec;
  color: #ff4d88;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
}

.contact-info p {
  font-size: 13px;
  margin: 5px 0;
}

.social-icons a {
  margin-right: 8px;
  color: #555;
}
.social-icons a:hover {
  color: orange;
}

.rating {
  color: orange;
  font-weight: 500;
}

/* ORANGE ACTIVE DROPDOWN */
.dropdown-item:active,
.dropdown-item.active {
  background-color: orange !important;
  color: white !important;
}
  .avatar-wrapper {
  position: relative;
  width: 90px;
  height: 90px;
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* OUTER ORANGE RING */
.avatar-wrapper::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2.5px solid orange;
  border-radius: 50%;
}

/* IMAGE PERFECT FIT */
.avatar-wrapper img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
  z-index: 1;
}

/* GREEN STATUS DOT (BOTTOM RIGHT) */
.status-dot {
  position: absolute;
  bottom: 6px;
  right: 12px;
  width: 12px;
  height: 12px;
  background: #22c55e; /* exact green */
  border-radius: 50%;
  border: 2px solid #fff;
  z-index: 2;
}

`
          }
        </style>
      </Row>


      {/* Modals */}
      <EditContactModal show={showEdit} onHide={() => setShowEdit(false)} />
           <AddContactModal
        show={contactShow}
        handleClose={() => setContactShow(false)}
      />
      <DeleteModal show={showDelete} onHide={() => setShowDelete(false)} />
        </div>
    </>
  );
}